// extracted by mini-css-extract-plugin
module.exports = {"widget":"FeedbackWidget_widget__2vTOU","activeTextbox":"FeedbackWidget_activeTextbox__1kHSx"};